import {  isDeliveryManager, userRole, hrRole } from "../../utils/userDetails";

let user=userRole;
const pathConstants={
    Home:'/',
    Timesheet:'/timesheet',
    EmployeeView:'/my-view',
}
if(hrRole) { 
    pathConstants.Dashboard = '/approval-dashboard';
}

if (isDeliveryManager) {
    pathConstants.DeliveryManager = '/timesheet-approval';
    pathConstants.view='/delivery-manager-view';
}

if(hrRole || isDeliveryManager){
    pathConstants.ProjectViewTimesheet= '/project-view';
    pathConstants.EmployeeViewTimesheet = '/employee-view';
}
export default pathConstants